import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-markLine",
  "use": "icon-markLine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-markLine\"><path d=\"M755.968 128a16 16 0 0 1 16 16v736a16 16 0 0 1-16 16h-128a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16zm-359.936 0a16 16 0 0 1 16 16v736a16 16 0 0 1-16 16h-128a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol